import { render, staticRenderFns } from "./FactorTable.vue?vue&type=template&id=f2bb7588&scoped=true&"
import script from "./FactorTable.vue?vue&type=script&lang=js&"
export * from "./FactorTable.vue?vue&type=script&lang=js&"
import style0 from "./FactorTable.vue?vue&type=style&index=0&id=f2bb7588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bb7588",
  null
  
)

export default component.exports